export const architectYourNextPageData = {
    navLinks: [
        { to: 'architecting-new-possibilities', label: 'Architecting New Possibilities' },
        { to: 'digital-core-capabilities', label: 'Digital Core Capabilities' },
        { to: 'digital-operating-model', label: 'Digital Operating Model' },
        { to: 'empowering-talent-transformation', label: 'Empowering Talent Transformation' },
        { to: 'tales-of-transformation', label: 'Tales of Transformation' },
    ],
    overview: {
        title: 'Overview',
        paragraphOne: 'In an era defined by rapid technological advancements and shifting market dynamics, the ability to architect your next move is crucial for sustained success. This section provides an overview of the key strategies and insights that can help businesses navigate the complexities of the digital landscape and position themselves for future growth.',
        paragraphTwo: "From embracing emerging technologies to fostering a culture of innovation, we explore the essential elements that contribute to successful transformation. Discover how to identify new opportunities, mitigate risks, and create a roadmap for your organization's future in this ever-evolving business environment.",
        paragraphThree: "Whether you're a seasoned executive or an aspiring leader, this section offers valuable perspectives and actionable insights to help you architect your next move with confidence and agility.",
    },
    videoSection: {
        title: 'Video Content',
    },
    aynSection: {
        title: 'KDA Design Technologies AYN',
        items: [
            {
                title: 'Digital Core Capabilities',
                to: '/architect-your-next/digital-core-capabilities/',
                className: 'gc1s4 ba pa1-00 h-100 w-100',
            },
            {
                title: 'Digital Operating Model',
                to: '/architect-your-next/digital-operating-model/',
                className: 'gc1s4 gr2s1 ba pa1-00',
            },
            {
                title: 'Tales of Transformation',
                to: '/architect-your-next/tales-of-transformation/',
                className: 'gc5s4 gr1s2 ba pa1-00',
            },
            {
                title: 'Empowering Talent Transformation',
                to: '/architect-your-next/empowering-talent-transformation/',
                className: 'gc9s4 gr1s1 ba pa1-00',
            },
            {
                title: 'Architecting New Possibilities',
                to: '/architect-your-next/architecting-new-possibilities/',
                className: 'gc9s4 gr2s1 ba pa1-00',
            },
        ],
    },
    researchSection: {
        title: 'KDA Design Technologies Research',
        subtitle: 'Exclusive report on the impact of digital disruption across industries.',
        footer: 'KDA Design Technologies Research & Development',
        reports: [
            { label: 'Report 1', className: 'gc1s6 vh-30 ba pa1-00 w-100' },
            { label: 'Report 2', className: 'gc7s3 vh-30 ba pa1-00 w-100' },
            { label: 'Report 3', className: 'gc10s3 gr1s1 ba pa1-00 w-100' },
            { label: 'Report 4', className: 'gc1s3 ba pa1-00 w-100' },
            { label: 'Report 5', className: 'gc4s3 vh-30 ba pa1-00 w-100' },
            { label: 'Report 6', className: 'gc7s3 vh-30 ba pa1-00 w-100' },
            { label: 'Report 7', className: 'gc10s3 vh-30 ba pa1-00 w-100' },
        ],
    },
    thoughtLeadershipSection: {
        title: 'Thought Leadership',
        subtitle: 'Our leaders share insights on Live Enterprise.',
        ctaLabel: 'Read More',
        ctaTo: 'thought-leadership',
        items: [
            { title: 'Article 1', details: 'a link to the article' },
            { title: 'Article 2', details: 'a link to the article' },
            { title: 'Article 3', details: '' },
            { title: 'Article 4', details: '' },
        ],
    },
    footerText: 'Architect Your Next Footer',
}
